import React from "react";

import Dashboard from "../../../layouts/Dashboard";
import { useParams } from "react-router-dom";
import { CalendarDetail } from "./CalendarDetail";

const CalendarDetailPage = () => {
  const { uuid } = useParams<{ uuid: string }>();

  return (
    <Dashboard>
      <CalendarDetail uuid={`cal${uuid}`} />
    </Dashboard>
  );
};

export default CalendarDetailPage;
